export default __webpack_public_path__ + "static/media/027-toy machine.d10e6725.svg";